import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { GENRES, slugify, genreColor } from "@/lib/genres";
import { PageTitle } from "@/components/site/ReleaseCard";
import { Reveal } from "@/components/site/Reveal";

export default function Genres() {
  const [counts, setCounts] = useState({});
  useEffect(() => { api.get("/genres").then((r) => setCounts(Object.fromEntries(r.data.map((g) => [g.slug, g])))).catch(() => {}); }, []);
  const extra = Object.values(counts).filter((g) => !GENRES.some((n) => slugify(n) === g.slug)).map((g) => g.name);
  const all = [...GENRES, ...extra].map((name) => ({ name, slug: slugify(name), count: counts[slugify(name)]?.count || 0 }))
    .sort((a, b) => b.count - a.count);

  return (
    <div data-testid="genres-page">
      <PageTitle over="Esplora" title="Generi" sub="Scopri i brani dell'etichetta divisi per genere, come su Beatport." />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {all.map((g, i) => (
          <Reveal key={g.slug} delay={(i % 8) * 50}>
            <Link to={`/generi/${g.slug}`} data-testid={`genre-tile-${g.slug}`}
              className={`lift group relative block overflow-hidden rounded-2xl border border-white/10 bg-[#1e2236] p-5 h-32 ${g.count ? "" : "opacity-60"}`}>
              <span className="absolute -right-8 -bottom-8 h-28 w-28 rounded-full opacity-30 group-hover:opacity-60 group-hover:scale-125 transition-[opacity,transform] duration-500" style={{ background: genreColor(g.name) }} />
              <span className="absolute left-0 top-0 h-full w-1.5" style={{ background: genreColor(g.name) }} />
              <p className="font-display font-bold uppercase leading-tight relative">{g.name}</p>
              <p className="font-mono-tga text-xs text-zinc-400 mt-2 relative" data-testid={`genre-count-${g.slug}`}>{g.count} {g.count === 1 ? "brano" : "brani"}</p>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
